import * as React from "react";
import PropTypes from "prop-types";

//MUI ELEMENTS
import Grid from "@mui/material/Grid";

class DropArea extends React.Component {

    constructor() {
        super();
        this.state = {
            dropAreaHilight: false,
            dragDropCounter: 0
        };
        this.boundPreventDefaults = this.preventDefaults.bind(this);
        this.boundHighlight = this.highlight.bind(this);
        this.boundUnHighlight = this.unhighlight.bind(this);
        this.boundHandleDrop = this.handleDrop.bind(this);
    }

    componentDidMount() {
        this.readyDropDownEvents();
    }

    componentWillUnmount() {
        this.removeDropDownEvents();
    }

    readyDropDownEvents() {
        this.removeDropDownEvents();
        ["dragenter", "dragleave", "drop", "dragover"].forEach(eventName => {
            document.addEventListener(eventName, this.boundPreventDefaults, false);
        });

        ["dragenter"].forEach(eventName => {
            document.addEventListener(eventName, this.boundHighlight, false);
        });

        ["dragleave", "drop"].forEach(eventName => {
            document.addEventListener(eventName, this.boundUnHighlight, false);
        });

        document.addEventListener("drop", this.boundHandleDrop, false);
    }

    removeDropDownEvents() {
        ["dragenter", "dragleave", "drop", "dragover"].forEach(eventName => {
            document.removeEventListener(eventName, this.boundPreventDefaults, false);
        });

        ["dragenter"].forEach(eventName => {
            document.removeEventListener(eventName, this.boundHighlight, false);
        });

        ["dragleave", "drop"].forEach(eventName => {
            document.removeEventListener(eventName, this.boundUnHighlight, false);
        });

        document.removeEventListener("drop", this.boundHandleDrop, false);
    }

    preventDefaults (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    // Utilisataion d'un counter car l'event dragleave est fired lors d'un hover sur un child
    highlight(e) {
        this.setState({ dropAreaHilight: true, dragDropCounter: this.state.dragDropCounter + 1 });
    }

    unhighlight(e) {
        if (e === "force" || this.state.dragDropCounter - 1 === 0) {
            this.setState({ dropAreaHilight: false, dragDropCounter: 0 });
        }
        else {
            this.setState({ dragDropCounter: this.state.dragDropCounter - 1 });
        }
    }

    handleDrop(e) {
        this.unhighlight("force");
        const dt = e.dataTransfer;
        const files = dt.files;
        this.props.handleDrop(files);
    }

    render() {
        return this.state.dropAreaHilight === true ?
            <div className="UploadHover" style={{
                backgroundColor:
                        "rgba(0, 0, 0, 0.5)" }}/> : null
        ;
    }
}

DropArea.propTypes = {
    handleDrop: PropTypes.func.isRequired
};

export default DropArea;
